import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Upload, AlertCircle, CheckCircle, X, FileText, Loader } from 'lucide-react';
import Modal from 'react-modal';

// Importar el archivo CSS
import './csv-importer-styles.css';
import { LoadingScreen } from '../../../components/LoadingScreen';
import { Crud_Catalogos, Crud_error } from "../../../herramientas/Crud_Catalogos";
import ModalLayout from '../../../components/ModalLayout.react';



const CSVImporter = (props) => {


  const [csvData, setCsvData] = useState([]);
  const [validationResults, setValidationResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [fileName, setFileName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patios,setPatios] = useState([])
  const [manualOpened, setManualOpened] = useState(() => {
    return localStorage.getItem('manualOpened') === 'true';
  });
  const [showManualModal, setShowManualModal] = useState(false);
  const [showAutoModal, setShowAutoModal] = useState(false);
  const [arrayDeMovimientos, setArrayDeMovimientos] = useState(
    (Array.isArray(props.movimientos?.movimientos_naviera_object) ? props.movimientos.movimientos_naviera_object : []).filter(m => m.movimientosGps == null  || m.movimientosGps.length == 0)
  );
  const [apiCache, setApiCache] = useState({
    remolques: null,
    patios: null,
    movimientos: null
  });
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState({ current: 0, total: 0 });
  const [validationProgress, setValidationProgress] = useState({ current: 0, total: 0 });
  const [loadingResults, setLoadingResults] = useState([]);
  const [showLoadingModal, setShowLoadingModal] = useState(false);


  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const usuario = JSON.parse(sessionStorage.getItem("usuario"));
  const fileInputRef = useRef(null);

  // useEffect para mostrar el modal automáticamente en la primera visita
  useEffect(() => {
    const manualOpened = localStorage.getItem('manualOpened');
    if (!manualOpened) {
      setShowAutoModal(true);
    }
  }, []);

  // Función para cerrar el modal del botón manual
  const closeManualModal = () => {
    setShowManualModal(false);
  };

  // Función para cerrar el modal automático
  const closeAutoModal = () => {
    setShowAutoModal(false);
    setManualOpened(true);
    localStorage.setItem('manualOpened', 'true');
  };

  // Limpiar cache cuando el componente se desmonte
  useEffect(() => {
    return () => {
      // Limpiar cache y requests pendientes al desmontar
      requestCache.current.clear();
      pendingRequests.current.clear();
    };
  }, []);

  // Catálogo de marcas
  const marcasCatalogo = [
    { nombre: "International" },
    { nombre: "Volvo" },
    { nombre: "Hino" },
    { nombre: "SCANNIA" },
    { nombre: "N/A" }
  ];


  // Crear índice una sola vez para optimizar búsquedas
  const movimientosIndex = useMemo(() => {
    const index = new Map();
    arrayDeMovimientos.forEach(m => {
      const key = `${m.idPlataforma?.id}-${m.idMovimientoTipo?.id}-${m.idCorredor?.id}`;
      if (!index.has(key)) {
        index.set(key, []);
      }
      index.get(key).push(m);
    });
    return index;
  }, [arrayDeMovimientos]);

  const validaFullOptimized = (movimiento) => {
    const movKey = `${movimiento.idPlataforma?.id}-${movimiento.idMovimientoTipo?.id}-${movimiento.idCorredor?.id}`;
    const candidatos = movimientosIndex.get(movKey) || [];

    // Recolectar IDs de movimientos que ya están siendo usados como full por otro
    const idsYaEnfullados = new Set();
    arrayDeMovimientos.forEach(m => {
      if (m.movimientosPatios?.length > 0 && m.movimientosPatios[0]?.esFull) {
        idsYaEnfullados.add(Number(m.movimientosPatios[0].esFull));
      }
    });

    let newMovs =  candidatos
      .filter(m => {
        // Excluir el mismo movimientoO
         
        
        if (movimiento.id === m.id) return false;
        
        // Buscar movimientos que NO tengan GPS (disponibles para enfullado)
        const noTieneGps = !m?.movimientosGps || m?.movimientosGps.length === 0;
        
        // Buscar movimientos que NO estén ya enfullados
        const noEstaEnfullado = !m?.movimientosPatios || 
                               m?.movimientosPatios.length === 0 || 
                               !m?.movimientosPatios[0]?.esFull;

        // Excluir movimientos que ya son full de otro movimiento
        const noEsFullDeOtro = !idsYaEnfullados.has(m.id);

      
        return noTieneGps && noEstaEnfullado && noEsFullDeOtro;
      })
      .map(m => ({
        
        id: m.id,
        label: `${m?.po} - ${m?.booking} - ${m?.contenedor}`,
        data: m,
      }));

      

      return newMovs;
  };

  // Mantener función original para compatibilidad
  const validaFull = validaFullOptimized;

  // Función para procesar datos por lotes (procesamiento asíncrono)
  const processBatch = async (items, batchSize, processor, onProgress) => {
    const results = [];
    const total = items.length;
    
    for (let i = 0; i < total; i += batchSize) {
      const batch = items.slice(i, i + batchSize);
      
      // Procesar lote actual
      for (let j = 0; j < batch.length; j++) {
        const result = await processor(batch[j], i + j, items);
        results.push(result);
        
        // Actualizar progreso
        if (onProgress) {
          onProgress({ current: i + j + 1, total });
        }
      }
      
      // Pausa para permitir que la UI se actualice
      await new Promise(resolve => setTimeout(resolve, 0));
    }
    
    return results;
  };

  // Mejoras en API calls
  const pendingRequests = useRef(new Map());
  const requestCache = useRef(new Map());
  const CACHE_TTL = 5 * 60 * 1000; // 5 minutos

  // Retry con backoff exponencial
  const fetchWithRetry = async (fetchFn, maxRetries = 3, baseDelay = 1000) => {
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        return await fetchFn();
      } catch (error) {
        if (attempt === maxRetries - 1) throw error;
        
        const delay = baseDelay * Math.pow(2, attempt);
        
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  };

  // Request deduplication y cache inteligente
  const optimizedFetchApiData = async (url, cacheKey) => {
    const fullKey = `${url}-${cacheKey}`;
    
    // Verificar cache
    const cached = requestCache.current.get(fullKey);
    if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
      return cached.data;
    }
    
    // Verificar si hay una request pendiente
    if (pendingRequests.current.has(fullKey)) {
      return pendingRequests.current.get(fullKey);
    }
    
    // Crear nueva request con retry
    const requestPromise = fetchWithRetry(async () => {
      return new Promise((resolve, reject) => {
        Crud_Catalogos(url, "", "get", "", patios)
          .then((data) => {
            // Guardar en cache
            requestCache.current.set(fullKey, {
              data,
              timestamp: Date.now()
            });
            
            // Actualizar estado si es necesario
            setApiCache(prev => ({ ...prev, [cacheKey]: data }));
            
            resolve(data);
          })
          .catch(reject);
      });
    });
    
    // Guardar request pendiente
    pendingRequests.current.set(fullKey, requestPromise);
    
    try {
      const result = await requestPromise;
      return result;
    } finally {
      // Limpiar request pendiente
      pendingRequests.current.delete(fullKey);
    }
  };

  // Función para hacer llamadas API con manejo de errores mejorado (legacy)
  // const fetchApiData = async (url, cacheKey) => {
  //   // Usar la versión optimizada
  //   return optimizedFetchApiData(url, cacheKey);
  // };

  // Debounced version para llamadas frecuentes
  const debouncedFetchApiData = useMemo(() => {
    let timeoutId;
    return (url, cacheKey, delay = 300) => {
      clearTimeout(timeoutId);
      return new Promise((resolve, reject) => {
        timeoutId = setTimeout(async () => {
          try {
            const result = await optimizedFetchApiData(url, cacheKey);
            resolve(result);
          } catch (error) {
            reject(error);
          }
        }, delay);
      });
    };
  }, []);

  // Batch API calls para múltiples requests
  const batchFetchApiData = async (requests) => {
    const results = {};
    const CONCURRENCY_LIMIT = 3;
    
    // Agrupar requests únicos
    const uniqueRequests = [...new Set(requests.map(r => `${r.url}-${r.cacheKey}`))];
    
    // Ejecutar en chunks para controlar concurrencia
    for (let i = 0; i < uniqueRequests.length; i += CONCURRENCY_LIMIT) {
      const chunk = uniqueRequests.slice(i, i + CONCURRENCY_LIMIT);
      
      const chunkPromises = chunk.map(async (requestKey) => {
        const [url, cacheKey] = requestKey.split('-');
        try {
          const result = await optimizedFetchApiData(url, cacheKey);
          results[requestKey] = { success: true, data: result };
        } catch (error) {
          results[requestKey] = { success: false, error: error.message };
        }
      });
      
      await Promise.all(chunkPromises);
      
      // Pausa entre chunks
      if (i + CONCURRENCY_LIMIT < uniqueRequests.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
    
    return results;
  };

  function getExcelColumnLetter(colIndex) {
    let result = '';
    while (colIndex > 0) {
      colIndex--; // Ajuste porque Excel es base 1, no base 0
      result = String.fromCharCode(65 + (colIndex % 26)) + result;
      colIndex = Math.floor(colIndex / 26);
    }
    return result;
  }

  function getColumnLetter(colNum) {
  let result = '';
  let num = colNum;
  
  while (num > 0) {
    num--; // Convertir a base 0
    const remainder = num % 26;
    result = String.fromCharCode(65 + remainder) + result;
    num = Math.floor(num / 26);
  }
  
  return result;
}
  

  // Función para descargar plantilla Excel con validaciones compatibles
  const downloadTemplate = async () => {
    try {
      const ExcelJS = await import('exceljs');
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Plantilla');
      
      // Headers
      const headers = [
        'movimiento','booking','contenedor','po','serviceOrder',
        'nombreOperador','contacto','vigenciaLicencia','TipoLicencia','placaTractor','EconomicoTractor',
        'marca','color','modelo','tipoRemolque','EconomicoRemolque','PlacaRemolque','esFull',
        'patio','unidadEnPatio','idMovimiento','placaremolquefull','economicoFull','tipoRemolqueFull','observaciones'
      ];
      
      worksheet.addRow(headers);
      
      // Configurar anchos de columnas (75% más anchos que el default de 8.43)
      worksheet.columns = [
        { width: 15 },  // A - movimiento
        { width: 18 },  // B - booking
        { width: 18 },  // C - contenedor
        { width: 15 },  // D - po
        { width: 18 },  // E - serviceOrder
        { width: 30 },  // F - nombreOperador (más ancho para nombres completos)
        { width: 18 },  // G - contacto
        { width: 18 },  // H - vigenciaLicencia
        { width: 15 },  // I - TipoLicencia
        { width: 15 },  // J - placaTractor
        { width: 18 },  // K - EconomicoTractor
        { width: 18 },  // L - marca
        { width: 15 },  // M - color
        { width: 12 },  // N - modelo
        { width: 18 },  // O - tipoRemolque
        { width: 18 },  // P - EconomicoRemolque
        { width: 18 },  // Q - PlacaRemolque
        { width: 10 },  // R - esFull
        { width: 20 },  // S - patio
        { width: 15 },  // T - unidadEnPatio
        { width: 35 },  // U - idMovimiento (largo para IDs compuestos)
        { width: 18 },  // V - placaremolquefull
        { width: 18 },  // W - economicoFull
        { width: 18 },  // X - tipoRemolqueFull
        { width: 25 },  // Y - observaciones
      ];
      
      // Cargar datos del API
      if (!apiCache.remolques && arrayDeMovimientos.length > 0 && currentUser.length > 0) {
        try {
          await optimizedFetchApiData(`remolques/plataforma/${currentUser[0].plataforma.id}`, 'remolques');
        } catch (error) {
          console.warn('Error cargando remolques:', error);
        }
      }
      
      if (!apiCache.patios && arrayDeMovimientos.length > 0) {
        try {
          await optimizedFetchApiData(`patios/transportista/${arrayDeMovimientos[0].idTransportista.id}`, 'patios');
        } catch (error) {
          console.warn('Error cargando patios:', error);
        }
      }

      // Cargar operadores, tractos y remolques del API (endpoints independientes)
      let operadoresData = [];
      let tractosData = [];
      let remolquesData = [];
      if (arrayDeMovimientos.length > 0) {
        const idTransportista = arrayDeMovimientos[0].idTransportista.id;
        try {
          // 1. Operadores independientes
          const operadoresRaw = await optimizedFetchApiData(
            `operadores/transportista/${idTransportista}`, 
            'operadores'
          );
          const operadoresArray = Array.isArray(operadoresRaw) ? operadoresRaw : [];
          // Filtrar vetados
          operadoresData = operadoresArray.filter(op => op.vetado !== true);
        } catch (error) {
          console.error('[CSVImporter] Error cargando operadores:', error);
        }
        try {
          // 2. Tractos independientes
          const tractosRaw = await optimizedFetchApiData(
            `unidadTerNav/idTransportista/${idTransportista}`,
            'tractos'
          );
          tractosData = (Array.isArray(tractosRaw) ? tractosRaw : []).filter(t => t.estatus !== false);
        } catch (error) {
          console.error('[CSVImporter] Error cargando tractos:', error);
        }
        try {
          // 3. Remolques: primero relaciones, luego detalle
          const relaciones = await optimizedFetchApiData(
            `remolques_transportistas/id_transportista/${idTransportista}`,
            'remolquesRelaciones'
          );
          const idsRemolques = [...new Set((Array.isArray(relaciones) ? relaciones : []).filter(r => r.idRemolque).map(r => r.idRemolque))];
          if (idsRemolques.length > 0) {
            const todosRemolques = await optimizedFetchApiData('remolques', 'remolquesTodos');
            remolquesData = (Array.isArray(todosRemolques) ? todosRemolques : []).filter(rem => idsRemolques.includes(rem.idRemolque));
          }
        } catch (error) {
          console.error('[CSVImporter] Error cargando remolques:', error);
        }
      }
      
      // Datos para validaciones
      const tiposRemolque = apiCache.remolques?.remolquesTipos?.length > 0
        ? apiCache.remolques.remolquesTipos.map(r => r.nombre.replace(/"/g, ''))
        : ['Seco', 'Refrigerado', 'Tanque', 'Plataforma', 'Caja Cerrada', 'Tolva'];
        
      const patiosDisponibles = apiCache.patios?.length > 0
        ? apiCache.patios.map(p => p.patio || p.nombre || p.id)
        : [];

      // Array de operadores disponibles (solo nombre + datos del operador)
      const operadoresDisponibles = operadoresData.map(op => {
        const nombre = `${op.nombre || ''} ${op.paterno || ''} ${op.materno || ''}`.trim();
        return {
          nombre,
          contacto: op.medioComunicacion || '',
          vigenciaLicencia: op.licenciaVigencia || '',
          tipoLicencia: op.licenciaTipo || '',
        };
      });

      // Array de tractos disponibles (independientes del operador)
      const tractosDisponibles = tractosData.map(t => ({
        placa: t.placa || '',
        economico: t.economico || '',
        marca: t.idUnidadMarca?.nombre || '',
        color: t.color || '',
        modelo: t.modelo || '',
      }));

      // Array de remolques disponibles (independientes del operador)
      const remolquesDisponibles = remolquesData.map(r => ({
        placa: r.placa || '',
        economico: r.economico || '',
        tipo: r.remolquesTipos?.nombre?.replace(/"/g, '') || '',
      }));

      // Array de marcas
      const marcasDisponibles = [
        'Freightliner', 'Kenworth', 'International', 'Volvo', 'Hino', 'SCANNIA', 'N/A'
      ];
      
      // Array de modelos (años)
      const startYear = 1997;
      const currentYear = new Date().getFullYear();
      const modelosDisponibles = [];
      for (let i = currentYear; i > startYear; i--) {
        modelosDisponibles.push(i.toString());
      }
      
      // Array de colores
      const coloresDisponibles = [
        'Acero', 'Agua', 'Aguacate o Palta', 'Aguamarina', 'Albaricoque', 'Almagre', 'Almendra', 'Aluminio', 'Aluminio Blanco', 'Aluminio Gris',
        'Amaranto', 'Amarillo', 'Amarillo Arena', 'Amarillo Azafrán', 'Amarillo Azufre', 'Amarillo Brillante', 'Amarillo Cadmio', 'Amarillo Chino',
        'Amarillo Colza', 'Amarillo Curry', 'Amarillo Dalia', 'Amarillo Fluorescente', 'Amarillo Hansa', 'Amarillo Indio', 'Amarillo Limón',
        'Amarillo Maiz', 'Amarillo Melón', 'Amarillo Miel', 'Amarillo Monoazo', 'Amarillo Naranja', 'Amarillo Narciso', 'Amarillo Nápoles',
        'Amarillo Ocre', 'Amarillo Oliva', 'Amarillo Oro', 'Amarillo Pastel', 'Amarillo Patito', 'Amarillo Retama', 'Amarillo Selectivo',
        'Amarillo Señales', 'Amarillo Sol', 'Amarillo Tráfico', 'Amarillo Verdoso', 'Amarillo de Cobalto', 'Amarillo de Cromo', 'Amarillo de Zinc',
        'Amatista', 'Anaranjado', 'Ante', 'Antracita', 'Arena', 'Asfalto', 'Aureolina', 'Avellana', 'Azabache', 'Azafrán', 'Azarcón', 'Azul',
        'Azul Acero', 'Azul Aciano', 'Azul Agua', 'Azul Alicia', 'Azul Azur', 'Azul Bebé o Azul Celeste', 'Azul Brillante', 'Azul Capri',
        'Azul Celeste', 'Azul Cerúleo', 'Azul Cian', 'Azul Cobalto', 'Azul Columbia', 'Azul Egipcio', 'Azul Eléctrico', 'Azul Eton', 'Azul Ftalo',
        'Azul Genciana', 'Azul Glauco', 'Azul Grisáceo', 'Azul Horizonte', 'Azul Klein', 'Azul Lavanda', 'Azul Lejanía', 'Azul Lino o Azulino',
        'Azul Luminoso', 'Azul Majorelle', 'Azul Marino', 'Azul Maya', 'Azul Medianoche', 'Azul Monastral', 'Azul Negruzco', 'Azul Noche',
        'Azul Noche Perlado', 'Azul Oceano', 'Azul Olombino', 'Azul Pastel', 'Azul Persa', 'Azul Porcelana', 'Azul Púrpura', 'Azul Real',
        'Azul Señales', 'Azul Tiffany', 'Azul Tráfico', 'Azul Turquesa', 'Azul Ultramar', 'Azul Verde', 'Azul Verdoso', 'Azul Violeta',
        'Azul Zafiro', 'Azul de Prusia', 'Azur', 'Añil', 'Banana', 'Barbecho', 'Begonia', 'Beige', 'Beige Agrisado', 'Beige Pardo',
        'Beige Perlado', 'Beige Verdoso', 'Beige o Beis', 'Berenjena', 'Bermejo', 'Bermellón', 'Bistre', 'Bistre Marrón', 'Blanco',
        'Blanco Crema', 'Blanco Grisáceo', 'Blanco Humo', 'Blanco Navajo', 'Blanco Papiro', 'Blanco Perla', 'Blanco Puro', 'Blanco Señales',
        'Blanco Tráfico', 'Blanco de Zinc/cinc', 'Borgoña', 'Borravino', 'Bronce', 'Bronceado', 'Burdeos', 'Burdeos Oscuro', 'Burdeos o Bordó',
        'Bígaro', 'Café', 'Café con Leche Cósmico', 'Calabaza', 'Calipso', 'Camello', 'Canela', 'Caoba', 'Caqui', 'Caramelo', 'Carbón',
        'Cardenal', 'Cardenillo', 'Cardo', 'Carmesí', 'Carmín', 'Carmín Alizarina', 'Carne o Carnación', 'Cartujo', 'Castaña o Castaño',
        'Castaño', 'Celeste', 'Ceniza', 'Cerceta', 'Cereza', 'Cerúleo', 'Cetrino', 'Champán', 'Chartreuse', 'Chocolate', 'Chocolate Magico',
        'Cian', 'Cielo', 'Ciruela', 'Cobre Perlado', 'Cobre o Cobrizo', 'Concha', 'Conchevino', 'Coral', 'Cordobán', 'Corinto', 'Crema',
        'Cuarzo', 'Damasco', 'Dark', 'Dorado', 'Durazno', 'Elefante', 'Encaje Antiguo', 'Escarlata', 'Esmeralda', 'Espinaca', 'Fandango',
        'Feldgrau', 'Frambuesa', 'Fucsia', 'Gamuza', 'Gencian Perlado', 'Geranio', 'Glauco', 'Grafito', 'Grana', 'Granate', 'Gris',
        'Gris Acorazado', 'Gris Amarillento', 'Gris Antracita', 'Gris Ardilla', 'Gris Azulado', 'Gris Basalto', 'Gris Beige', 'Gris Cadete',
        'Gris Caqui', 'Gris Cemento', 'Gris Ceniza', 'Gris Claro Perlado', 'Gris Cuarzo', 'Gris Frío', 'Gris Grafita', 'Gris Granito',
        'Gris Guijarro', 'Gris Hierro', 'Gris Hormigón', 'Gris Lona', 'Gris Luminoso', 'Gris Musgo', 'Gris Musgo Perlado', 'Gris Negruzco',
        'Gris Oliva', 'Gris Oscuro Perlado', 'Gris Parduzco', 'Gris Piedra', 'Gris Pizarra', 'Gris Plata', 'Gris Platino', 'Gris Polvo',
        'Gris Ratón', 'Gris Seda', 'Gris Señales', 'Gris Sombra', 'Gris Tele 1', 'Gris Tele 2', 'Gris Tele 4', 'Gris Tráfico B',
        'Gris Tráfico a', 'Gris Ventana', 'Gris Verdoso', 'Gris de Campaña', 'Gris de Davy', 'Gris de Payne', 'Gris Ágata', 'Gualda o Gualdo',
        'Guinda', 'Gules', 'Guta o Gutagamba', 'Habano', 'Herrumbre', 'Hielo', 'Hojaldre', 'Hueso', 'Humo', 'Hígado', 'Jade', 'Kalua',
        'Lacre', 'Ladrillo', 'Ladrillo Oscuro', 'Lapislázuli', 'Latón', 'Lava', 'Lava Fundida', 'Lavanda', 'León o Leonado', 'Lila',
        'Lila Azulado', 'Lima', 'Lima-limón', 'Limón', 'Lino', 'Lirio', 'Llama', 'Lombarda', 'Lúcuma', 'Magenta', 'Magenta Tele', 'Malaquita',
        'Malva', 'Mamey', 'Mandarina', 'Marfil', 'Marfil Claro', 'Marmol', 'Marron Castaño', 'Marrón Cuero', 'Marrón Dorado', 'Marrón Señales',
        'Marrón Tierra', 'Maíz', 'Melocotón', 'Melón', 'Menta', 'Miel', 'Molvada', 'Morado', 'Morado Perlado', 'Mostaza', 'Musgo', 'Naranja',
        'Naranja Brillante', 'Naranja Cadmio', 'Naranja Caqui', 'Naranja Claro Brillante', 'Naranja Intenso', 'Naranja Perlado', 'Naranja Persa',
        'Naranja Puro', 'Naranja Pálido', 'Naranja Rojizo', 'Naranja Salmón', 'Naranja Sanguineo', 'Naranja Señales', 'Naranja Tráfico',
        'Naranja de Portland', 'Negro', 'Negro Bujía', 'Negro Grafito', 'Negro Intenso', 'Negro Señales', 'Negro Tráfico', 'Negro de Humo',
        'Nogal', 'Níquel', 'Ocaso', 'Ocre', 'Ocre Amarillo', 'Ocre Dorado', 'Ocre Pardo', 'Ocre Rojo', 'Oliva', 'Oliva Grisáceo',
        'Oliva Negruzco', 'Oliva Parduzco', 'Oro', 'Oro Perlado', 'Oro Viejo', 'Orquídea', 'Palo Rosa', 'Palta o Aguacate', 'Pardo',
        'Pardo Anaranjado', 'Pardo Arcilla', 'Pardo Beige', 'Pardo Cobre', 'Pardo Corzo', 'Pardo Grisáceo', 'Pardo Negruzco', 'Pardo Nuez',
        'Pardo Ocre', 'Pardo Oliva', 'Pardo Pálido', 'Pardo Rojo', 'Pardo Verdoso', 'Perla', 'Perú', 'Piel', 'Pistacho', 'Pizarra',
        'Plata o Plateado', 'Platino', 'Plomo', 'Porcelana', 'Porráceo', 'Puerro', 'Punzó', 'Purpúreo', 'Púrpura', 'Púrpura Eléctrico',
        'Púrpura Francés', 'Púrpura de Tiro', 'Púrpurá Tráfico', 'Quercitrón', 'Quermes', 'Rojo', 'Rojo Anaranjado', 'Rojo Beige',
        'Rojo Brillante', 'Rojo Carmin', 'Rojo Claro Anaranjado', 'Rojo Claro Brillante', 'Rojo Coral', 'Rojo Falun', 'Rojo Ferrari',
        'Rojo Frambuesa', 'Rojo Fresa', 'Rojo Fucsia', 'Rojo Indio', 'Rojo Lila', 'Rojo Magenta', 'Rojo Negruzco', 'Rojo Neón', 'Rojo Oriente',
        'Rojo Pardo', 'Rojo Periodo', 'Rojo Persa', 'Rojo Puro', 'Rojo Purpura', 'Rojo Púrpura', 'Rojo Rubí', 'Rojo Rubí Perlado',
        'Rojo Salmón', 'Rojo Sangre', 'Rojo Señales', 'Rojo Tomate', 'Rojo Toscano', 'Rojo Tráfico', 'Rojo Upsdell', 'Rojo Veneciano',
        'Rojo Viejo', 'Rojo Vino', 'Rojo Violeta', 'Rojo Vivo', 'Rojo Óxido', 'Rosa', 'Rosa Claro', 'Rosa Coral', 'Rosa Lavanda', 'Rosa Malva',
        'Rosa Mexicano', 'Rosa Mountbatten', 'Rosa Naranja', 'Rosa Perlado', 'Rosa Shocking', 'Rosa o Rosado', 'Rosado Claro', 'Rubí', 'Rufo',
        'Salmón', 'Salvia', 'Salvia Azulado', 'Sangría', 'Secuoya', 'Sepia', 'Siena', 'Siena Tostada', 'Sinople', 'Teja', 'Tomate',
        'Torcaza o Topo', 'Trigo', 'Turquesa', 'Turquesa Menta', 'Turquesa Pastel', 'Turquí', 'Té Verde', 'Ultramar', 'Uva', 'Vainilla',
        'Verde', 'Verde Abeto', 'Verde Agua', 'Verde Amarillento', 'Verde Amarillo', 'Verde Azulado', 'Verde Bosque', 'Verde Botella',
        'Verde Brillante', 'Verde Británico de Carreras', 'Verde Caña', 'Verde Ceniza', 'Verde Cian', 'Verde Claro', 'Verde Cromo',
        'Verde Esmeralda', 'Verde Ftalo', 'Verde Helecho', 'Verde Hierba', 'Verde Hoja', 'Verde Hooker', 'Verde Lanquecino', 'Verde Limón',
        'Verde Loro', 'Verde Luminoso', 'Verde Manzana', 'Verde Mar', 'Verde Mayo', 'Verde Menta', 'Verde Militar', 'Verde Musgo',
        'Verde Negruzco', 'Verde Oliva', 'Verde Opalo', 'Verde Oscuro', 'Verde Parduzco', 'Verde Patina', 'Verde Perlado', 'Verde Petróleo',
        'Verde Pino', 'Verde Primavera', 'Verde Puro', 'Verde Pálido', 'Verde Reseda', 'Verde Señales', 'Verde Tráfico', 'Verde Turquesa',
        'Verde Veronese o Veronés', 'Verde de París o de Schweinfurt', 'Verde Ópalo Perlado', 'Verdete, Verdín o Verdigrís', 'Vino o Vinotinto',
        'Violeta', 'Violeta Pastel', 'Violeta Perlado', 'Violeta Púrpura', 'Violeta Señales', 'Violeta Érica', 'Violín', 'Viridián',
        'Viridián/veridian', 'Wasabi', 'Wengué', 'Wisteria', 'Xanadú', 'Xántico', 'Yema', 'Yeso', 'Zafiro', 'Zanahoria', 'Zinc', 'Ámbar', 'Ébano'
      ];
      
      // Filtrar movimientos que no tengan información en movimientosPatios
      // y que coincidan con la plataforma seleccionada
      const plataformaSearch = props.plataformaSeleccionada?.search || '';
      const movimientosFiltrados = (arrayDeMovimientos || []).filter(m => 
        (!m.movimientosPatios || m.movimientosPatios.length === 0) &&
        (plataformaSearch === '' || m.idPlataforma?.nombre?.includes(plataformaSearch))
      );
      
      // Agregar datos de movimientos filtrados
      const movimientos = movimientosFiltrados;
      movimientos.forEach(mov => {
        worksheet.addRow([
          mov.id || '', mov.booking || '', mov.contenedor || '', mov.po || '', mov.service_order || '',
          '','','','','','','','','','','','','false','','','','','','',''
        ]);
      });
      
      // Crear hoja de validaciones separada (método más compatible)
      const validationSheet = workbook.addWorksheet('Validaciones');
      
      // Agregar listas de validación en columnas separadas
      validationSheet.getCell('A1').value = 'TiposRemolque';
      tiposRemolque.forEach((tipo, index) => {
        validationSheet.getCell(`A${index + 2}`).value = tipo;
      });
      
      validationSheet.getCell('B1').value = 'EsFull';
      validationSheet.getCell('B2').value = 'true';
      validationSheet.getCell('B3').value = 'false';
      
      validationSheet.getCell('C1').value = 'Patios';
      patiosDisponibles.forEach((patio, index) => {
        validationSheet.getCell(`C${index + 2}`).value = patio;
      });
      
      validationSheet.getCell('D1').value = 'UnidadEnPatio';
      validationSheet.getCell('D2').value = 'Activo';
      validationSheet.getCell('D3').value = 'Inactivo';
      
      validationSheet.getCell('E1').value = 'Colores';
      coloresDisponibles.forEach((color, index) => {
        validationSheet.getCell(`E${index + 2}`).value = color;
      });
      
      validationSheet.getCell('F1').value = 'Marcas';
      marcasDisponibles.forEach((marca, index) => {
        validationSheet.getCell(`F${index + 2}`).value = marca;
      });
      
      validationSheet.getCell('G1').value = 'Modelos';
      modelosDisponibles.forEach((modelo, index) => {
        validationSheet.getCell(`G${index + 2}`).value = modelo;
      });

      // Columna H para nombres de operadores (dropdown)
      const operadorNombres = operadoresDisponibles.map(op => op.nombre);
      validationSheet.getCell('H1').value = 'Operadores';
      operadorNombres.forEach((nombre, index) => {
        validationSheet.getCell(`H${index + 2}`).value = nombre;
      });
      if (operadorNombres.length === 0) {
        console.error('[CSVImporter] NO SE ENCONTRARON OPERADORES - El dropdown estara vacio');
      }

      // Columna I_VAL para placas de tractos (dropdown independiente)
      const tractoPlacas = tractosDisponibles.map(t => t.placa ? `${t.placa} - ${t.economico}` : '').filter(Boolean);
      const colIndexTractos = 26; // Columna Z para no interferir con las de movimientos
      const colLetterTractos = getColumnLetter(colIndexTractos);
      validationSheet.getCell(`${colLetterTractos}1`).value = 'Tractos';
      tractoPlacas.forEach((placa, index) => {
        validationSheet.getCell(`${colLetterTractos}${index + 2}`).value = placa;
      });

      // Columna siguiente para placas de remolques (dropdown independiente)
      const remolquePlacas = remolquesDisponibles.map(r => r.placa ? `${r.placa} - ${r.economico}` : '').filter(Boolean);
      const colIndexRemolques = 27; // Columna AA
      const colLetterRemolques = getColumnLetter(colIndexRemolques);
      validationSheet.getCell(`${colLetterRemolques}1`).value = 'Remolques';
      remolquePlacas.forEach((placa, index) => {
        validationSheet.getCell(`${colLetterRemolques}${index + 2}`).value = placa;
      });

      // Crear hoja oculta "DatosOperadores" con campos para auto-relleno via VLOOKUP
      // NUEVO: Solo datos del operador (contacto, vigencia, licencia)
      const datosOpSheet = workbook.addWorksheet('DatosOperadores');
      datosOpSheet.getRow(1).values = [
        'nombreOperador', 'contacto', 'vigenciaLicencia', 'TipoLicencia'
      ];
      operadoresDisponibles.forEach((op, index) => {
        datosOpSheet.getRow(index + 2).values = [
          op.nombre, op.contacto, op.vigenciaLicencia, op.tipoLicencia
        ];
      });
      datosOpSheet.state = 'veryHidden';

      // Crear hoja oculta "DatosTractos" para auto-relleno via VLOOKUP por placa
      const datosTractoSheet = workbook.addWorksheet('DatosTractos');
      datosTractoSheet.getRow(1).values = [
        'placaTracto', 'economico', 'marca', 'color', 'modelo'
      ];
      tractosDisponibles.forEach((t, index) => {
        const labelTracto = t.placa ? `${t.placa} - ${t.economico}` : '';
        datosTractoSheet.getRow(index + 2).values = [
          labelTracto, t.economico, t.marca, t.color, t.modelo
        ];
      });
      datosTractoSheet.state = 'veryHidden';

      // Crear hoja oculta "DatosRemolques" para auto-relleno via VLOOKUP por placa
      const datosRemolqueSheet = workbook.addWorksheet('DatosRemolques');
      datosRemolqueSheet.getRow(1).values = [
        'placaRemolque', 'economico', 'tipo'
      ];
      remolquesDisponibles.forEach((r, index) => {
        const labelRemolque = r.placa ? `${r.placa} - ${r.economico}` : '';
        datosRemolqueSheet.getRow(index + 2).values = [
          labelRemolque, r.economico, r.tipo
        ];
      });
      datosRemolqueSheet.state = 'veryHidden';
      
      // Ocultar la hoja de validaciones
      validationSheet.state = 'veryHidden';
      
      // Aplicar validaciones usando referencias a la hoja oculta
      const startRow = 2;
      const endRow = movimientos.length + 1;
      
      if (endRow >= startRow) {
        // Las columnas O(tipoRemolque), R(esFull), L(marca), M(color), N(modelo) 
        // se auto-rellenan con VLOOKUP - no necesitan dropdown
        
        // Validación para esFull (columna R) - dropdown con true/false
        worksheet.dataValidations.add(`R${startRow}:R${endRow}`, {
          type: 'list',
          allowBlank: false,
          formulae: ['Validaciones!$B$2:$B$3']
        });

        // Validación para patio (columna S)
        worksheet.dataValidations.add(`S${startRow}:S${endRow}`, {
          type: 'list',
          allowBlank: true,
          formulae: [`Validaciones!$C$2:$C$${patiosDisponibles.length + 1}`]
        });
        
        // Validación para unidadEnPatio (columna T)
        worksheet.dataValidations.add(`T${startRow}:T${endRow}`, {
          type: 'list',
          allowBlank: true,
          formulae: ['Validaciones!$D$2:$D$3']
        });
        
        // Crear rango vacío en Validaciones (usado por V y U cuando esFull=false)
        const colIndexVacio = 28; // Columna AB
        const colLetterVacio = getColumnLetter(colIndexVacio);
        validationSheet.getCell(`${colLetterVacio}1`).value = 'Vacio';
        validationSheet.getCell(`${colLetterVacio}2`).value = '';

        // Validaciones para idMovimiento específicas por fila (columna U)
        // Usar columnas a partir de la I (9) porque H está reservada para operadores
        let colIndex = 9; // Empezar en columna I de la hoja de validaciones
        movimientos.forEach((mov, index) => {
          const rowNumber = index + 2;
          try {
            const movimientosValidos = validaFull(mov);
            
            if (movimientosValidos && movimientosValidos.length > 0) {
              const opciones = movimientosValidos.map(m => {
                const po = (m.data?.po || 'SIN_PO').replace(/[,"]/g, '');
                const booking = (m.data?.booking || 'SIN_BOOKING').replace(/[,"]/g, '');
                const contenedor = (m.data?.contenedor || 'SIN_CONTENEDOR').replace(/[,"]/g, '');
                return `${m.id}-${po}-${booking}-${contenedor}`;
              });
              
              // Agregar opciones en la hoja de validaciones
              const colLetter = getColumnLetter(colIndex);

              validationSheet.getCell(`${colLetter}1`).value = `Mov_${rowNumber}`;
              opciones.forEach((opcion, opIndex) => {
                validationSheet.getCell(`${colLetter}${opIndex + 2}`).value = opcion;
              });
              
              // Aplicar validación solo a esta fila específica (columna U = idMovimiento)
              // Solo permite seleccionar cuando esFull=true, vacío cuando esFull=false
              worksheet.dataValidations.add(`U${rowNumber}:U${rowNumber}`, {
                type: 'list',
                allowBlank: true,
                formulae: [`INDIRECT(IF(R${rowNumber}="true","Validaciones!$${colLetter}$2:$${colLetter}$${opciones.length + 1}","Validaciones!$${colLetterVacio}$2:$${colLetterVacio}$2"))`]
              });
              
              colIndex++;
            }
          } catch (error) {
            console.warn(`Error generando validación para fila ${rowNumber}:`, error);
          }
        });

        // Validación para nombreOperador (columna F) - dropdown con nombres de operadores
        if (operadorNombres.length > 0) {
          worksheet.dataValidations.add(`F${startRow}:F${endRow}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Validaciones!$H$2:$H$${operadorNombres.length + 1}`]
          });
        }

        // Validación para placaTractor (columna J) - dropdown con tractos independientes
        if (tractoPlacas.length > 0) {
          worksheet.dataValidations.add(`J${startRow}:J${endRow}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Validaciones!$${colLetterTractos}$2:$${colLetterTractos}$${tractoPlacas.length + 1}`]
          });
        }

        // Validación para PlacaRemolque (columna Q) - dropdown con remolques independientes
        if (remolquePlacas.length > 0) {
          worksheet.dataValidations.add(`Q${startRow}:Q${endRow}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Validaciones!$${colLetterRemolques}$2:$${colLetterRemolques}$${remolquePlacas.length + 1}`]
          });
        }

        // Validación para placaremolquefull (columna V) - dropdown condicional
        // Usa INDIRECT para que solo muestre opciones cuando esFull=true
        if (remolquePlacas.length > 0) {
          for (let row = startRow; row <= endRow; row++) {
            worksheet.dataValidations.add(`V${row}:V${row}`, {
              type: 'list',
              allowBlank: true,
              formulae: [`INDIRECT(IF(R${row}="true","Validaciones!$${colLetterRemolques}$2:$${colLetterRemolques}$${remolquePlacas.length + 1}","Validaciones!$${colLetterVacio}$2:$${colLetterVacio}$2"))`]
            });
          }
        }

        // NUEVO FLUJO: VLOOKUPs independientes
        // Operador (F) → auto-rellena G(contacto), H(vigencia), I(licencia)
        // Tracto (J = "placa - eco") → auto-rellena K(ecoTractor), L(marca), M(color), N(modelo)
        // Remolque (Q = "placa - eco") → auto-rellena O(tipoRemolque), P(ecoRemolque)
        
        const opCount = operadoresDisponibles.length + 1;
        const tractoCount = tractosDisponibles.length + 1;
        const remolqueCount = remolquesDisponibles.length + 1;

        for (let row = startRow; row <= endRow; row++) {
          // Operador VLOOKUP: F → G, H, I
          if (operadoresDisponibles.length > 0) {
            worksheet.getCell(`G${row}`).value = { formula: `IFERROR(VLOOKUP(F${row},DatosOperadores!$A$1:$D$${opCount},2,FALSE),"")` };
            worksheet.getCell(`H${row}`).value = { formula: `IFERROR(VLOOKUP(F${row},DatosOperadores!$A$1:$D$${opCount},3,FALSE),"")` };
            worksheet.getCell(`I${row}`).value = { formula: `IFERROR(VLOOKUP(F${row},DatosOperadores!$A$1:$D$${opCount},4,FALSE),"")` };
          }
          // Tracto VLOOKUP: J → K, L, M, N
          if (tractosDisponibles.length > 0) {
            worksheet.getCell(`K${row}`).value = { formula: `IFERROR(VLOOKUP(J${row},DatosTractos!$A$1:$E$${tractoCount},2,FALSE),"")` };
            worksheet.getCell(`L${row}`).value = { formula: `IFERROR(VLOOKUP(J${row},DatosTractos!$A$1:$E$${tractoCount},3,FALSE),"")` };
            worksheet.getCell(`M${row}`).value = { formula: `IFERROR(VLOOKUP(J${row},DatosTractos!$A$1:$E$${tractoCount},4,FALSE),"")` };
            worksheet.getCell(`N${row}`).value = { formula: `IFERROR(VLOOKUP(J${row},DatosTractos!$A$1:$E$${tractoCount},5,FALSE),"")` };
          }
          // Remolque VLOOKUP: Q → P, O
          if (remolquesDisponibles.length > 0) {
            worksheet.getCell(`P${row}`).value = { formula: `IFERROR(VLOOKUP(Q${row},DatosRemolques!$A$1:$C$${remolqueCount},2,FALSE),"")` };
            worksheet.getCell(`O${row}`).value = { formula: `IFERROR(VLOOKUP(Q${row},DatosRemolques!$A$1:$C$${remolqueCount},3,FALSE),"")` };
          }
          // Remolque Full VLOOKUP: V → W (economicoFull), X (tipoRemolqueFull)
          if (remolquesDisponibles.length > 0) {
            worksheet.getCell(`W${row}`).value = { formula: `IFERROR(VLOOKUP(V${row},DatosRemolques!$A$1:$C$${remolqueCount},2,FALSE),"")` };
            worksheet.getCell(`X${row}`).value = { formula: `IFERROR(VLOOKUP(V${row},DatosRemolques!$A$1:$C$${remolqueCount},3,FALSE),"")` };
          }
        }
      }
      
      // Crear hoja de instrucciones
      const instructionsSheet = workbook.addWorksheet('Instrucciones');
      instructionsSheet.addRow(['INSTRUCCIONES DE USO']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['NUEVO FLUJO: Operador, Tracto y Remolque son INDEPENDIENTES']);
      instructionsSheet.addRow(['Ya NO hay vinculacion fija entre operador y unidad.']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['COLUMNAS CON SELECTORES DESPLEGABLES (editables):']);
      instructionsSheet.addRow(['- nombreOperador (F): Selector con operadores del catalogo']);
      instructionsSheet.addRow(['  → Auto-rellena: contacto, vigenciaLicencia, TipoLicencia']);
      instructionsSheet.addRow(['- placaTractor (J): Selector con tractos del transportista']);
      instructionsSheet.addRow(['  → Auto-rellena: EconomicoTractor, marca, color, modelo']);
      instructionsSheet.addRow(['- PlacaRemolque (Q): Selector con remolques del transportista']);
      instructionsSheet.addRow(['  → Auto-rellena: tipoRemolque, EconomicoRemolque']);
      instructionsSheet.addRow([`- patio (S): ${patiosDisponibles.join(', ')}`]);
      instructionsSheet.addRow(['- unidadEnPatio (T): Activo, Inactivo']);
      instructionsSheet.addRow(['- esFull (R): true, false']);
      instructionsSheet.addRow(['- idMovimiento (U): Opciones especificas por fila']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['COLUMNAS AUTO-RELLENADAS (no editables):']);
      instructionsSheet.addRow(['- G (contacto), H (vigencia), I (licencia) ← se llenan al seleccionar operador']);
      instructionsSheet.addRow(['- K (ecoTractor), L (marca), M (color), N (modelo) ← se llenan al seleccionar tracto']);
      instructionsSheet.addRow(['- O (tipoRemolque), P (ecoRemolque) ← se llenan al seleccionar remolque']);
      instructionsSheet.addRow(['- W (economicoFull), X (tipoRemolqueFull) ← se llenan al seleccionar remolque full']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['COLUMNAS EDITABLES ADICIONALES:']);
      instructionsSheet.addRow(['- esFull (R): Selector desplegable con true/false (siempre obligatorio)']);
      instructionsSheet.addRow(['- patio (S, dropdown), unidadEnPatio (T, dropdown)']);
      instructionsSheet.addRow(['- idMovimiento (U, dropdown por fila) - solo si esFull=true']);
      instructionsSheet.addRow(['- placaremolquefull (V, dropdown con remolques) - solo si esFull=true']);
      instructionsSheet.addRow(['  → Auto-rellena: economicoFull (W), tipoRemolqueFull (X)']);
      instructionsSheet.addRow(['- observaciones (Y) - texto libre']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['IMPORTANTE: Cuando esFull = true, completar:']);
      instructionsSheet.addRow(['- idMovimiento, placaremolquefull, economicoFull, tipoRemolqueFull, observaciones']);
      instructionsSheet.addRow(['']);
      instructionsSheet.addRow(['NOTA: Los selectores funcionan haciendo clic en la flecha']);
      instructionsSheet.addRow(['que aparece al lado derecho de cada celda.']);

      // --- PROTECCION DE HOJA ---
      // NUEVO FLUJO INDEPENDIENTE:
      // Columnas auto-rellenadas (bloqueadas): G(7), H(8), I(9) [operador], K(11), L(12), M(13), N(14) [tracto], O(15), P(16) [remolque]
      // Columnas editables (desbloqueadas): A(1)-E(5) datos mov, F(6) operador, J(10) tracto, Q(17) remolque, R(18) esFull, S(19) patio, T(20) unidadEnPatio, U(21) idMov, V(22)-X(24) full, Y(25) observaciones
      
      // Por defecto en ExcelJS todas las celdas estan bloqueadas cuando se protege la hoja.
      // Necesitamos desbloquear las celdas editables.
      const editableColumns = [1, 2, 3, 4, 5, 6, 10, 17, 18, 19, 20, 21, 22, 25]; // A-E, F, J, Q, R-U, V(placaRemFull), Y(observaciones). W y X se auto-rellenan
      
      for (let row = startRow; row <= endRow; row++) {
        editableColumns.forEach(col => {
          const cell = worksheet.getCell(row, col);
          cell.protection = { locked: false };
        });
      }
      
      // Tambien desbloquear la fila de headers para que sea visible
      for (let col = 1; col <= 25; col++) {
        worksheet.getCell(1, col).protection = { locked: true };
      }

      // Proteger la hoja - permite seleccionar celdas bloqueadas (para ver valores) pero no editarlas
      worksheet.protect('', {
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: false,
        autoFilter: true,
      });
      
      // Generar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'plantilla_operadores_selectores.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error generando plantilla:', error);
      alert('Error al generar la plantilla Excel');
    }
  };

  // Validaciones completas
  const validateDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date) && dateString === date.toISOString().split('T')[0];
  };

  const validateYear = (yearString) => {
    const regex = /^\d{4}$/;
    if (!regex.test(yearString)) return false;
    const year = parseInt(yearString, 10);
    return year >= 1900 && year <= new Date().getFullYear() + 5;
  };

  const validateMarca = (marca) => {
    return marcasCatalogo.some(m => m.nombre.toLowerCase() === marca.toLowerCase());
  };

  // Función principal de validación completa
  const validateRow = (row, rowIndex, allData) => {
    const errors = [];
    
    // Validar campos requeridos básicos
    const requiredFields = [
      'tipoRemolque', 'EconomicoRemolque', 'PlacaRemolque', 'esFull',
      'patio', 'unidadEnPatio', 'movimiento'
    ];

    requiredFields.forEach(field => {
      if (!row[field] || row[field].toString().trim() === '') {
        const fieldNames = {
          nombreOperador: 'Nombre del operador',
          contacto: 'Contacto',
          vigenciaLicencia: 'Vigencia de licencia',
          TipoLicencia: 'Tipo de licencia',
          placaTractor: 'Placa del tractor',
          EconomicoTractor: 'Económico del tractor',
          marca: 'Marca',
          color: 'Color',
          modelo: 'Modelo',
          tipoRemolque: 'Tipo de remolque',
          EconomicoRemolque: 'Económico del remolque',
          PlacaRemolque: 'Placa del remolque',
          esFull: 'Es Full',
          patio: 'Patio',
          unidadEnPatio: 'Unidad en patio',
          movimiento: 'ID Movimiento',
          booking: 'Booking',
          contenedor: 'Contenedor',
          po: 'PO'
        };
        const friendlyName = fieldNames[field] || field;
        errors.push(`El campo "${friendlyName}" es obligatorio y no puede estar vacío.`);
      }
    });

    // Validar campos adicionales si esFull tiene información
    const esFullValue = row.esFull?.toString().toLowerCase();
    const hasFullInfo = esFullValue && esFullValue.trim() !== '';
    const isFullTrue = ['true', '1', 'activo'].includes(esFullValue);

    if (hasFullInfo && isFullTrue) {
      // Campos adicionales requeridos cuando esFull=true
      const fullRequiredFields = ['idMovimiento', 'placaremolquefull', 'economicoFull', 'observaciones'];
      
      fullRequiredFields.forEach(field => {
        if (!row[field] || row[field].toString().trim() === '') {
          const fieldNames = {
            idMovimiento: 'ID del movimiento',
            placaremolquefull: 'Placa del remolque full',
            economicoFull: 'Económico full',
            observaciones: 'Observaciones'
          };
          const friendlyName = fieldNames[field] || field;
          errors.push(`El campo "${friendlyName}" es obligatorio cuando el registro es Full (esFull = Activo).`);
        }
      });

      // Validar que idMovimiento no esté duplicado (solo para registros activos)
      if (row.idMovimiento && row.idMovimiento.toString().trim() !== '') {
        const idMovimientoCompleto = row.idMovimiento.toString().trim();
        // Extraer solo el ID de la nomenclatura id-po-booking-contenedor
        const idMovimiento = idMovimientoCompleto.split('-')[0];
        
        // Verificar duplicados en el mismo archivo (solo entre registros activos)
        const duplicatesInFile = allData.filter((otherRow, otherIndex) => {
          if (otherIndex === rowIndex) return false;
          const otherEsFull = otherRow.esFull?.toString().toLowerCase();
          const otherIsFullTrue = ['true', '1', 'activo'].includes(otherEsFull);
          if (!otherIsFullTrue) return false; // Solo validar contra registros activos
          
          const otherIdMovimiento = otherRow.idMovimiento?.toString().trim();
          if (!otherIdMovimiento) return false;
          
          const otherIdMovimientoId = otherIdMovimiento.split('-')[0];
          return otherIdMovimientoId === idMovimiento;
        });

        if (duplicatesInFile.length > 0) {
          const duplicateRows = duplicatesInFile.map((dupRow) => `fila ${allData.indexOf(dupRow) + 2}`).join(', ');
          errors.push(`El ID de movimiento "${idMovimiento}" ya esta asignado a un movimiento enfullado (aparece en: ${duplicateRows}). Cada ID debe ser único.`);
        }

        // Verificar si el idMovimiento ya está enfullado en el sistema
        const movimientoEnfullado = arrayDeMovimientos.find(m => {
          return m.id?.toString() === idMovimiento && 
                 m.movimientosPatios && 
                 m.movimientosPatios.length > 0 && 
                 m.movimientosPatios[0].esFull;
        });

        if (movimientoEnfullado) {
          const movimientoPrincipalId = movimientoEnfullado.movimientosPatios[0].esFull;
          errors.push(`No se puede enfullar el movimiento "${idMovimiento}" porque ya está enfullado por el movimiento principal "${movimientoPrincipalId}".`);
        }

        // Validar contra validaFull cuando esFull tiene información
        try {
          const movimientoActual = arrayDeMovimientos.find(m => m.id?.toString() === row.movimiento?.toString());
          if (movimientoActual) {
            const movimientosValidos = validaFull(movimientoActual);
            
            const isValidMovimiento = movimientosValidos.some(m => 
              m.id?.toString() === idMovimiento ||
              m.data?.id?.toString() === idMovimiento
            );
            
            if (!isValidMovimiento) {
              errors.push(`El código de movimiento "${idMovimiento}" no existe en los movimientos Full válidos para este movimiento.`);
            }
          }
        } catch (error) {
          errors.push(`No se pudo validar el código de movimiento "${idMovimiento}": ${error.message}`);
        }
      }
    }

    // Validar que si esFull=false, no se haya llenado placa de remolque full
    if (hasFullInfo && !isFullTrue) {
      if (row.placaremolquefull && row.placaremolquefull.toString().trim() !== '') {
        errors.push(`No se puede asignar una placa de remolque full cuando "esFull" es false. Limpia el campo "placaremolquefull" o cambia "esFull" a true.`);
      }
      if (row.idMovimiento && row.idMovimiento.toString().trim() !== '') {
        errors.push(`No se puede asignar un ID de movimiento full cuando "esFull" es false. Limpia el campo "idMovimiento" o cambia "esFull" a true.`);
      }
    }

    // Validar vigencia de licencia
    // if (row.vigenciaLicencia && !validateDate(row.vigenciaLicencia)) {
    //   errors.push(`La fecha de vigencia "${row.vigenciaLicencia}" no es válida. Debe usar el formato año-mes-día (ej: 2025-12-31).`);
    // }

    // Validar marca
    // if (row.marca && !validateMarca(row.marca)) {
    //   const marcasPermitidas = marcasCatalogo.map(m => m.nombre).join(', ');
    //   errors.push(`La marca "${row.marca}" no está permitida. Las marcas válidas son: ${marcasPermitidas}.`);
    // }

    // Validar modelo (año)
    // if (row.modelo && !validateYear(row.modelo)) {
    //   errors.push(`El modelo "${row.modelo}" no es válido. Debe ser un año entre 1900 y ${new Date().getFullYear() + 5} (ej: 2020).`);
    // }

    // tipoRemolque viene auto-rellenado del operador, no se valida contra catalogo



    // Validar patio via API (simulado)
    if (row.patio) {
      try {
        // Simulamos la validación de API
        const patiosCatalogo = [];

        patiosCatalogo.push(apiCache.patios.map(r => 
                                  r.patio
        ));

        let isValidPatio = patiosCatalogo.filter(p => {
          return p[0].toString().toLowerCase() == row.patio.toLowerCase();
        });
        // if(patiosCatalogo.length > 0){
        //   catalogoPatios = catalogoPatios[0];
        // }
        // const isValidPatio = patiosCatalogo[0].map(p => {
        //   return p?.toString().toLowerCase() == row.patio.toLowerCase(); 
        // });
        if (!isValidPatio) {
          errors.push(`El patio "${row.patio}" no existe. Verifica el catálogo de patios de transportista disponibles.`);
        }
      } catch (error) {
        errors.push(`No se pudo validar el patio "${row.patio}": ${error.message}`);
      }
    }

    // Validar esFull cuando tiene información
    if (hasFullInfo) {
      if (!['true', 'false', '1', '0', 'activo', 'inactivo'].includes(esFullValue)) {
        errors.push(`El campo "Es Full" debe ser "Activo", "Inactivo", "true", "false", "1" o "0". El valor "${row.esFull}" no es válido.`);
      }
    }

    // Validar movimientoId
    if (row.movimiento && row.movimiento.toString().trim() !== '') {
      const movimiento = row.movimiento.toString().trim();
      const movimientos = arrayDeMovimientos || [];
      
      const isValidMovimiento = movimientos.some(m => 
        m.id?.toString() === movimiento
      );
      
      if (!isValidMovimiento) {
        errors.push(`El ID de movimiento "${movimiento}" no existe en el catálogo de movimientos.`);
      } else {
        // Verificar si este movimiento ya está siendo usado como idMovimiento en otro registro activo
        const otherFullRecord = allData.find((otherRow, otherIndex) => {
          if (otherIndex === rowIndex) return false;
          const otherEsFull = otherRow.esFull?.toString().toLowerCase();
          const otherIsFullTrue = ['true', '1', 'activo'].includes(otherEsFull);
          if (!otherIsFullTrue) return false; // Solo validar contra registros activos
          
          const otherIdMovimiento = otherRow.idMovimiento?.toString().trim();
          if (!otherIdMovimiento) return false;
          
          const otherIdMovimientoId = otherIdMovimiento.split('-')[0];
          return otherIdMovimientoId === movimiento;
        });

        if (otherFullRecord) {
          const otherRowNumber = allData.indexOf(otherFullRecord) + 2;
          errors.push(`No se puede usar el movimiento "${movimiento}" como movimiento principal porque ya está siendo usado como movimiento enfullado (idMovimiento) en la fila ${otherRowNumber}.`);
        }
      }
    }

    return {
      rowIndex: rowIndex + 1,
      data: row,
      isValid: errors.length === 0,
      errors,
      esFull: isFullTrue
    };
  };

  // Selección de archivo
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && (file.type === 'text/csv' || file.name.endsWith('.csv'))) {
      setFileName(file.name);
      processCSV(file);
    } else if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx'))) {
      setFileName(file.name);
      processExcel(file);
    } else {
      alert('Por favor selecciona un archivo CSV (.csv) o Excel (.xlsx) válido.');
    }
    // Reset input value para permitir cargar el mismo archivo
    event.target.value = '';
  };

  // Procesar Excel con validación completa
  const processExcel = async (file) => {
    setIsLoading(true);
    setIsValidating(false);
    setCsvData([]);
    setValidationResults([]);
    setFileName(file.name);

    try {
      const ExcelJS = await import('exceljs');
      const workbook = new ExcelJS.Workbook();
      const buffer = await file.arrayBuffer();
      await workbook.xlsx.load(buffer);
      
      const worksheet = workbook.getWorksheet('Plantilla') || workbook.getWorksheet(1);
      if (!worksheet) {
        throw new Error('No se encontró una hoja de trabajo válida en el archivo Excel.');
      }

      const rows = [];
      const headers = [];
      
      // Obtener headers de la primera fila
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell, colNumber) => {
        headers[colNumber - 1] = cell.text || cell.value || '';
      });
      
      if (headers.length === 0) {
        throw new Error('El archivo Excel no contiene encabezados válidos.');
      }

      // Procesar filas de datos (desde la fila 2)
      for (let rowNumber = 2; rowNumber <= worksheet.rowCount; rowNumber++) {
        const row = worksheet.getRow(rowNumber);
        const rowData = {};
        let hasData = false;
        
        headers.forEach((header, index) => {
          const cell = row.getCell(index + 1);
          const value = cell.text || cell.value || '';
          rowData[header] = value.toString().trim();
          if (value.toString().trim() !== '') hasData = true;
        });
        
        if (hasData) {
          rows.push(rowData);
        }
      }
      
      if (rows.length === 0) {
        throw new Error('El archivo Excel no contiene datos para procesar.');
      }

      setCsvData(rows);

      // Validar cada fila con procesamiento asíncrono
      setIsValidating(true);
      setValidationProgress({ current: 0, total: rows.length });
      
      const results = await processBatch(
        rows,
        1000, // Procesar 50 filas por lote
        async (row, index, allData) => {
          return validateRow(row, index, allData);
        },
        (progress) => {
          setValidationProgress(progress);
        }
      );
      
      setIsValidating(false);

      setValidationResults(results);
    } catch (error) {
      console.error('Error procesando Excel:', error);
      alert(`Error procesando el archivo Excel: ${error.message}`);
    } finally {
      setIsLoading(false);
      setIsValidating(false);
    }
  };

  // Procesar CSV con validación completa
  const processCSV = async (file) => {
    setIsLoading(true);
    setIsValidating(false);
    setCsvData([]);
    setValidationResults([]);
    setFileName(file.name);

    try {
      const text = await file.text();
      const lines = text.split('\n').filter(line => line.trim() !== '');
      
      if (lines.length === 0) {
        throw new Error('El archivo CSV está vacío o no contiene datos válidos.');
      }
      
      if (lines.length === 1) {
        throw new Error('El archivo CSV solo contiene encabezados pero no tiene datos para procesar.');
      }

      const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
      
      // Validar que tenga los campos mínimos requeridos
      const requiredHeaders = ['nombreOperador', 'contacto', 'vigenciaLicencia', 'esFull'];
      const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
      
      if (missingHeaders.length > 0) {
        throw new Error(`El archivo CSV no contiene las columnas requeridas: ${missingHeaders.join(', ')}. Descarga la plantilla para verificar la estructura correcta.`);
      }
      
      const data = lines.slice(1).map((line, index) => {
        try {
          const values = line.split(',').map(v => v.trim().replace(/"/g, ''));
          const row = {};
          headers.forEach((header, headerIndex) => {
            const value = values[headerIndex] || '';
            row[header] = (header === 'operadorLicenciaVigencia' && value === '') ? null : value;
          });
          return row;
        } catch (error) {
          throw new Error(`Error procesando la fila ${index + 2}: ${error.message}`);
        }
      });

      setCsvData(data);

      // Validar cada fila con procesamiento asíncrono
      setIsValidating(true);
      setValidationProgress({ current: 0, total: data.length });
      
      const results = await processBatch(
        data,
        50, // Procesar 50 filas por lote
        async (row, index, allData) => {
          return validateRow(row, index, allData);
        },
        (progress) => {
          setValidationProgress(progress);
        }
      );
      
      setIsValidating(false);

      setValidationResults(results);
    } catch (error) {
      console.error('Error procesando CSV:', error);

    } finally {
      setIsLoading(false);
      setIsValidating(false);
    }
  };

  // Función para cargar datos via API
  const loadDataViaAPI = async () => {
    const validData = validationResults.filter(result => result.isValid).map(result => {
      const data = { ...result.data };
      if (data.operadorLicenciaVigencia === '') {
        data.operadorLicenciaVigencia = null;
      }
      return data;
    });
    
    if (validData.length === 0) {
      alert('No hay datos válidos para cargar');
      return;
    }

    setIsLoadingData(true);
    setShowLoadingModal(true);
    setLoadingProgress({ current: 0, total: validData.length });
    setLoadingResults([]);

    for (let i = 0; i < validData.length; i++) {
      const row = validData[i];
      
      setLoadingProgress({ current: i, total: validData.length });
      await new Promise(resolve => setTimeout(resolve, 100));

      try {
        const remolque = apiCache.remolques?.remolquesTipos?.find(r => {
          let nombre = r.nombre.replace(/"/g, "")
          return nombre.toLowerCase() === row.tipoRemolque?.toLowerCase()
        }) || null;

        const patio = apiCache.patios?.find(p => 
          p.patio?.toLowerCase() === row.patio?.toLowerCase()
        );

        const isEnPatio = row.unidadEnPatio?.toLowerCase() === 'activo' || row.unidadEnPatio?.toLowerCase() === 'true' || row.unidadEnPatio === '1';
        const currentDateTime = isEnPatio ? new Date().toISOString().slice(0, 19).replace('T', ' ') : null;
        const idMovimientoFull = row.idMovimiento ? row.idMovimiento.toString().split('-')[0] : null;

        // Parsear placa de tracto y remolque (vienen en formato "PLACA - ECO")
        const parsePlacaEco = (val) => {
          if (!val) return { placa: '', economico: '' };
          const parts = val.split(' - ');
          return { placa: (parts[0] || '').trim(), economico: (parts[1] || '').trim() };
        };
        const tractoParseado = parsePlacaEco(row.placaTractor);
        const remolqueParseado = parsePlacaEco(row.PlacaRemolque);

        // Verificar si el movimiento ya tiene MovimientosPatio
        const movimientoExistente = arrayDeMovimientos.find(m => m.id?.toString() === row.movimiento?.toString());
        const tieneMovimientoPatio = movimientoExistente?.movimientosPatios && movimientoExistente.movimientosPatios.length > 0;
        const movimientoPatioId = tieneMovimientoPatio ? movimientoExistente.movimientosPatios[0].id : null;

        // Detectar esFull: puede ser 'true', 'activo', '1'
        const esFullValue = row.esFull?.toString().toLowerCase();
        const isFullTrue = ['true', '1', 'activo'].includes(esFullValue);

        const requestData = {
          ...(tieneMovimientoPatio ? { id: movimientoPatioId } : {}),
          economicor: row.EconomicoRemolque || remolqueParseado.economico,
          economicot: row.EconomicoTractor || tractoParseado.economico,
          enPatio: currentDateTime,
          idColocacionPatio: patio?.id || null,
          idMovimiento: parseInt(row.movimiento),
          idRemolque: remolque ? { idRemolque: remolque.idRemolque } : { idRemolque: 1 },
          idUsuario: { id: usuario?.id },
          operadorContacto: row.contacto,
          operadorLicencia: row.TipoLicencia,
          operadorLicenciaVigencia: row.vigenciaLicencia == "" ? null : row.vigenciaLicencia,
          operadorNombre: row.nombreOperador,
          remolquePlaca: remolqueParseado.placa,
          tractorColor: row.color,
          tractorMarca: row.marca,
          tractorModelo: row.modelo,
          tractorPlaca: tractoParseado.placa,
          ...(isFullTrue && idMovimientoFull ? {
            esFull: parseInt(idMovimientoFull)
          } : {})
        };

        // Usar PUT si ya existe MovimientoPatio, POST si no existe
        const method = tieneMovimientoPatio ? "put" : "post";
        const url = "movimientosPatio";
        const urlWithId = tieneMovimientoPatio ? movimientoPatioId : "";
        
        // Primera petición: Movimiento principal
        const data = await new Promise((resolve, reject) => {
          Crud_Catalogos(url, urlWithId, method, "", requestData, "", "", "", [])
            .then(resolve)
            .catch(reject);
        });

        // Segunda petición: Movimiento enfullado (si aplica)
        if (isFullTrue && idMovimientoFull && (data?.id || tieneMovimientoPatio)) {
          // Verificar si el movimiento full ya tiene MovimientosPatio
          const movimientoFullExistente = arrayDeMovimientos.find(m => m.id?.toString() === idMovimientoFull);
          const tieneMovimientoPatioFull = movimientoFullExistente?.movimientosPatios && movimientoFullExistente.movimientosPatios.length > 0;
          const movimientoPatioFullId = tieneMovimientoPatioFull ? movimientoFullExistente.movimientosPatios[0].id : null;
          
          // Request para movimiento enfullado: usar datos del principal pero cambiar económicos y placa
          const remolqueFullParseado = parsePlacaEco(row.placaremolquefull);
          const requestDataFull = {
            ...(tieneMovimientoPatioFull ? { id: movimientoPatioFullId } : {}),
            economicor: row.economicoFull || remolqueFullParseado.economico,
            economicot: row.EconomicoTractor || tractoParseado.economico,
            enPatio: currentDateTime,
            idColocacionPatio: patio?.id || null,
            idMovimiento: parseInt(idMovimientoFull),  // ID del movimiento enfullado
            idRemolque: remolque ? { idRemolque: remolque.idRemolque } : { idRemolque: 1 },
            idUsuario: { id: usuario?.id },
            operadorContacto: row.contacto,
            operadorLicencia: row.TipoLicencia,
            operadorLicenciaVigencia: row.vigenciaLicencia == "" ? null : row.vigenciaLicencia,
            operadorNombre: row.nombreOperador,
            remolquePlaca: remolqueFullParseado.placa || row.placaremolquefull || '',
            tractorColor: row.color,
            tractorMarca: row.marca,
            tractorModelo: row.modelo,
            tractorPlaca: tractoParseado.placa,
            observaciones: row.observaciones || '',
            esFull: parseInt(row.movimiento)  // ID del movimiento principal que lo enfulla
          };
          
          // Usar PUT si ya existe MovimientoPatio para el movimiento full, POST si no existe
          const methodFull = tieneMovimientoPatioFull ? "put" : "post";
          const urlFull = "movimientosPatio";
          const urlWithIdFull = tieneMovimientoPatioFull ? movimientoPatioFullId : "";
          
          await new Promise((resolve, reject) => {
            Crud_Catalogos(urlFull, urlWithIdFull, methodFull, "", requestDataFull, "", "", "", [])
              .then(resolve)
              .catch(reject);
          });
        }

        setLoadingResults(prev => [...prev, {
          row: i + 1,
          data: row,
          success: true,
          response: data
        }]);

      } catch (error) {
        setLoadingResults(prev => [...prev, {
          row: i + 1,
          data: row,
          success: false,
          error: error.message || error.toString()
        }]);
      }
      
      setLoadingProgress({ current: i + 1, total: validData.length });
    }

    setIsLoadingData(false);
  };

  // Función para exportar datos válidos
  const exportValidData = () => {
    const validData = validationResults.filter(result => result.isValid).map(result => result.data);
    if (validData.length === 0) {
      alert('No hay datos válidos para exportar');
      return;
    }

    const csvContent = [
      Object.keys(validData[0]).join(','),
      ...validData.map(row => Object.values(row).map(val => `"${val}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `datos_validos_${Date.now()}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };


  const validCount = validationResults.filter(r => r.isValid).length;
  const invalidCount = validationResults.filter(r => !r.isValid).length;
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') closeModal();
    };
    if (isModalOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }

  }, [isModalOpen]);

  

  useEffect(() => {
    // Usar batch API calls para cargar datos iniciales
    const loadInitialData = async () => {
      if (arrayDeMovimientos.length > 0 && currentUser.length > 0) {
        const requests = [
          { url: `patios/transportista/${arrayDeMovimientos[0].idTransportista.id}`, cacheKey: 'patios' },
          { url: `remolques/plataforma/${currentUser[0].plataforma.id}`, cacheKey: 'remolques' }
        ];
        
        try {
          const results = await batchFetchApiData(requests);

        } catch (error) {
          console.error('Error loading initial data:', error);
        }
      }
    };
    
    loadInitialData();
  }, [arrayDeMovimientos, currentUser])
  
  return (
    <div className="csv-importer-container">
      {/* Header */}
      <div className="csv-importer-header">
        <h1 className="csv-importer-title">Carga masiva de asignaciones</h1>
        <p className="csv-importer-subtitle">
          Importa un archivo Excel
        </p>
        
        <div className="mb-4" style={{display: 'flex', gap: '44px'}}>
          <button
            onClick={downloadTemplate}
            className="csv-importer-template-button"
          >
            <FileText />
            Descargar Plantilla
          </button>
          <button
            onClick={() => setShowManualModal(true)}
            className="csv-importer-template-button"
            style={{backgroundColor: '#14b8a6', marginLeft: '0.5rem'}}
          >
            <FileText />
            Manual
          </button>
        </div>
        
        {/* Modal del botón Manual */}
        <Modal
          isOpen={showManualModal}
          onRequestClose={closeManualModal}
          ariaHideApp={false}
          style={{
            content: {
              position: 'relative',
              top: '60px',
              width: '80%',
              height: 'auto',
              margin: 'auto',
              zIndex: 70,
            }
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Manual SKYONE</h4>
              <button
                type="button"
                className="btn btn-dark fa fa-close outline pill"
                onClick={closeManualModal}
              />
            </div>
            <div className="modal-body">
              <iframe 
                src="/archivos/MANUAL SKYONE.pdf" 
                width="100%" 
                height="600px"
                title="Manual SKYONE"
                style={{ border: 'none' }}
              />
            </div>
          </div>
        </Modal>
        
        {/* Modal automático para primera visita */}
        <Modal
          isOpen={showAutoModal}
          onRequestClose={closeAutoModal}
          ariaHideApp={false}
          style={{
            content: {
              position: 'relative',
              top: '60px',
              width: '80%',
              height: 'auto',
              margin: 'auto',
              zIndex: 70,
            }
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Manual SKYONE</h4>
              <button
                type="button"
                className="btn btn-dark fa fa-close outline pill"
                onClick={closeAutoModal}
              />
            </div>
            <div className="modal-body">
              <iframe 
                src="/archivos/MANUAL SKYONE.pdf" 
                width="100%" 
                height="600px"
                title="Manual SKYONE"
                style={{ border: 'none' }}
              />
            </div>
          </div>
        </Modal>
      </div>
      {/* DISEÑO HORIZONTAL: ÁREA DE CARGA + RESUMEN DE VALIDACIÓN */}
      <div className="csv-importer-layout">
        
        {/* COLUMNA 1: ÁREA DE CARGA */}
        <div className="csv-importer-column csv-upload-area">
          <h3 className="csv-upload-title">Cargar Archivo CSV o Excel</h3>
          <div className="csv-upload-dropzone">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileSelect}
              accept=".csv,.xlsx"
              className="hidden"
            />
            
            <div className="csv-upload-content">
              {!fileName ? (
                <div>
                  <Upload className="csv-upload-icon" />
                  <p className="csv-upload-main-text">Selecciona tu archivo CSV o Excel</p>
                  <p className="csv-upload-sub-text">
                    Descarga la plantilla Excel para ver la estructura correcta
                  </p>
                  <button
                    onClick={() => fileInputRef.current?.click()}
                    className="csv-upload-button"
                  >
                    Elegir Archivo
                  </button>
                </div>
              ) : (
                <div>
                  <FileText className="csv-upload-selected-icon" />
                  <p className="csv-upload-selected-text">Archivo cargado:</p>
                  <p className="csv-upload-filename">{fileName}</p>
                  <button
                    onClick={() => fileInputRef.current?.click()}
                    className="csv-upload-change-button"
                  >
                    Cambiar Archivo
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* COLUMNA 2: RESUMEN DE VALIDACIÓN */}
        <div className="csv-importer-column">
          {validationResults.length > 0 && !isLoading && !isValidating ? (
            <div className="csv-summary-container">
              <h2 className="csv-summary-title">Resumen de Validación</h2>
              <div className="csv-summary-grid">
                <div className="csv-summary-card">
                  <div className="csv-summary-number">{validationResults.length}</div>
                  <div className="csv-summary-label">Total de registros</div>
                </div>
                <div className="csv-summary-card-green">
                  <div className="csv-summary-number-green">{validCount}</div>
                  <div className="csv-summary-label-green">Registros válidos</div>
                </div>
                <div className="csv-summary-card-red">
                  <div className="csv-summary-number-red">{invalidCount}</div>
                  <div className="csv-summary-label-red">Registros con errores</div>
                </div>
              </div>

              <div className="csv-summary-actions">
                <button
                  onClick={openModal}
                  className="csv-summary-button"
                >
                  <FileText />
                  Ver Detalles de Validación
                </button>
                
                {validCount > 0 && (
                  <>
                    <button 
                      onClick={loadDataViaAPI}
                      className="csv-summary-button-green"
                      disabled={isLoadingData}
                    >
                      {isLoadingData ? 'Cargando...' : `Cargar Datos (${validCount})`}
                    </button>
                    <button 
                      onClick={exportValidData}
                      className="csv-summary-button"
                    >
                      Exportar Datos Válidos ({validCount})
                    </button>
                  </>
                )}
              </div>
              
              {/* Observaciones importantes */}
              <div style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                borderLeft: '4px solid #007bff',
                borderRadius: '4px',
                fontSize: '14px'
              }}>
                <h4 style={{ margin: '0 0 10px', color: '#495057', fontSize: '14px', fontWeight: '600' }}>
                  📋 Observaciones Importantes
                </h4>
                <div style={{ color: '#6c757d', lineHeight: '1.5' }}>
                  <p style={{ margin: '0 0 8px' }}>
                    <strong>✅ Plantilla con validaciones:</strong>
                  </p>
                  <ul style={{ margin: '0', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '4px' }}>Las columnas tienen selectores desplegables</li>
                    <li style={{ marginBottom: '4px' }}>Cada fila tiene opciones específicas de ID Movimiento</li>
                    <li style={{ marginBottom: '4px' }}>Revisa la hoja "Instrucciones" para más detalles</li>
                  </ul>
                </div>
              </div>

            </div>
          ) : (
            <div className="csv-info-area">
              <h3 className="csv-info-title">Estado del Análisis</h3>
              <p className="csv-upload-sub-text">
                {isLoading 
                  ? "Procesando archivo..." 
                  : isValidating
                    ? "Validando datos del Excel..."
                    : fileName 
                      ? "Archivo cargado, listo para procesar" 
                      : "Selecciona un archivo CSV para comenzar el análisis"
                }
              </p>
              
              {/* Observaciones cuando no hay archivo */}
              {!fileName && (
                <div style={{
                  marginTop: '20px',
                  padding: '15px',
                  backgroundColor: '#e3f2fd',
                  borderLeft: '4px solid #2196f3',
                  borderRadius: '4px',
                  fontSize: '13px'
                }}>
                  <h4 style={{ margin: '0 0 8px', color: '#1976d2', fontSize: '13px', fontWeight: '600' }}>
                    💡 Consejos para usar la plantilla Excel
                  </h4>
                  <div style={{ color: '#424242', lineHeight: '1.4' }}>
                    <p style={{ margin: '0 0 6px' }}>• Descarga la plantilla con validaciones incluidas</p>
                    <p style={{ margin: '0 0 6px' }}>• Usa los selectores desplegables en las columnas</p>
                    <p style={{ margin: '0' }}>• Revisa la hoja "Instrucciones" para más información</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Loader de pantalla completa */}
      {(isLoading || isValidating) && (
        <div className="csv-fullscreen-loader">
          <div className="csv-fullscreen-overlay"></div>
          <div className="csv-fullscreen-content">
            <div className="csv-loading-truck-container">
              <div className="csv-loading-truck">🚛</div>
              <div className="csv-loading-documents">📋</div>
              <div className="csv-loading-road"></div>
            </div>
            
            <div className="csv-loading-text">
              {isValidating ? "Validando archivo" : "Procesando archivo"}
            </div>
            <div className="csv-loading-subtext">
              {isValidating 
                ? `Verificando datos y validando campos... ${validationProgress.current}/${validationProgress.total}` 
                : "Leyendo archivo y preparando validación..."
              }
            </div>
            
            <div className="csv-loading-progress">
              <div className="csv-loading-progress-bar">
                <div 
                  className="csv-loading-progress-fill"
                  style={{
                    width: isValidating && validationProgress.total > 0 
                      ? `${(validationProgress.current / validationProgress.total) * 100}%`
                      : '50%'
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal con errores detallados */}
      {isModalOpen && (
        <div 
          className="csv-modal-overlay"
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className="csv-modal">
            <div className="csv-modal-header">
              <h2 className="csv-modal-title">Resultados de Validación</h2>
              <button onClick={closeModal} className="csv-modal-close">
                <X />
              </button>
            </div>

            <div className="csv-modal-content">
              {/* Resumen detallado */}
              <div className="csv-modal-summary">
                <div className="csv-modal-summary-grid">
                  <div className="csv-modal-summary-card">
                    <div className="csv-modal-summary-number">{validationResults.length}</div>
                    <div className="csv-modal-summary-label">Total procesados</div>
                  </div>
                  <div className="csv-modal-summary-card-green">
                    <div className="csv-modal-summary-number-green">{validCount}</div>
                    <div className="csv-modal-summary-label-green">Válidos</div>
                    <div className="csv-modal-summary-percentage csv-modal-summary-percentage-green">
                      {validationResults.length > 0 ? Math.round((validCount / validationResults.length) * 100) : 0}% del total
                    </div>
                  </div>
                  <div className="csv-modal-summary-card-red">
                    <div className="csv-modal-summary-number-red">{invalidCount}</div>
                    <div className="csv-modal-summary-label-red">Con errores</div>
                    <div className="csv-modal-summary-percentage csv-modal-summary-percentage-red">
                      {validationResults.length > 0 ? Math.round((invalidCount / validationResults.length) * 100) : 0}% del total
                    </div>
                  </div>
                </div>
              </div>

              {/* Lista de resultados con errores detallados */}
              <h3 className="csv-modal-results-title">Detalle por Registro</h3>
              <div className="csv-modal-results-container">
                {validationResults.map((result, index) => (
                  <div key={index} className={`csv-modal-result-item ${result.isValid ? 'csv-modal-result-valid' : 'csv-modal-result-invalid'}`}>
                    <div className="csv-modal-result-header">
                      <div className="csv-modal-result-info">
                        <span className="csv-modal-result-name">
                          Registro {result.rowIndex}: {result.data.nombreOperador || 'Sin nombre'}
                        </span>
                        {result.esFull && (
                          <span className="csv-modal-result-tag">Full</span>
                        )}
                      </div>
                      {result.isValid ? <CheckCircle /> : <AlertCircle />}
                    </div>
                    
                    {result.errors.length > 0 && (
                      <div className="csv-modal-result-errors">
                        <p className="csv-modal-result-errors-title">Errores encontrados:</p>
                        <div className="csv-modal-result-errors-list">
                          {result.errors.map((error, errorIndex) => (
                            <div key={errorIndex} className="csv-modal-result-error-item">
                              <X className="csv-modal-result-error-icon" />
                              <span>{error}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {result.isValid && (
                      <div className="csv-modal-result-success">
                        ✓ Todos los campos son válidos
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="csv-modal-footer">
              <div className="csv-modal-footer-info">
                {validCount > 0 && (
                  <span className="csv-modal-footer-info-valid">
                    {validCount} registros listos para procesar
                  </span>
                )}
                {invalidCount > 0 && (
                  <span className="csv-modal-footer-info-invalid">
                    {invalidCount} registros necesitan corrección
                  </span>
                )}
              </div>
              <div className="csv-modal-footer-actions">
                {validCount > 0 && (
                  <>
                    <button
                      onClick={() => {
                        loadDataViaAPI();
                        closeModal();
                      }}
                      className="csv-modal-footer-export-button"
                      disabled={isLoadingData}
                    >
                      {isLoadingData ? 'Cargando...' : `Cargar Datos (${validCount})`}
                    </button>
                    <button
                      onClick={() => {
                        exportValidData();
                        closeModal();
                      }}
                      className="csv-modal-footer-button"
                    >
                      Exportar Válidos ({validCount})
                    </button>
                  </>
                )}
                <button onClick={closeModal} className="csv-modal-footer-button">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de carga mejorado */}
      {showLoadingModal && (
        <div className="csv-modal-overlay">
          <div className="csv-modal" style={{ maxWidth: '600px' }}>
            <div className="csv-modal-header">
              <h2 className="csv-modal-title">Cargando Datos al Sistema</h2>
              {!isLoadingData && (
                <button onClick={() => setShowLoadingModal(false)} className="csv-modal-close">
                  <X />
                </button>
              )}
            </div>

            <div className="csv-modal-content">
              {/* Progreso principal con porcentaje */}
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div style={{ 
                  width: '120px', 
                  height: '120px', 
                  margin: '0 auto 20px', 
                  position: 'relative',
                  borderRadius: '50%',
                  background: `conic-gradient(#10b981 ${(loadingProgress.current / loadingProgress.total) * 360}deg, #e5e7eb 0deg)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <div style={{
                    width: '90px',
                    height: '90px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                  }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#10b981' }}>
                      {Math.round((loadingProgress.current / loadingProgress.total) * 100)}%
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {loadingProgress.current}/{loadingProgress.total}
                    </div>
                  </div>
                </div>
                
                <h3 style={{ margin: '0 0 10px', color: '#374151' }}>
                  {isLoadingData ? 'Procesando registros...' : 'Proceso completado'}
                </h3>
                
                {isLoadingData && (
                  <p style={{ color: '#6b7280', margin: '0' }}>
                    Enviando registro {loadingProgress.current} de {loadingProgress.total}
                  </p>
                )}
              </div>

              {/* Estadísticas en tiempo real */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '15px', 
                marginBottom: '25px' 
              }}>
                <div style={{
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#f3f4f6',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#374151' }}>
                    {loadingProgress.current}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>Procesados</div>
                </div>
                
                <div style={{
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#ecfdf5',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#10b981' }}>
                    {loadingResults.filter(r => r.success).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#059669' }}>Exitosos</div>
                </div>
                
                <div style={{
                  textAlign: 'center',
                  padding: '15px',
                  backgroundColor: '#fef2f2',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#ef4444' }}>
                    {loadingResults.filter(r => !r.success).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#dc2626' }}>Errores</div>
                </div>
              </div>

              {/* Barra de progreso lineal */}
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  width: '100%',
                  height: '8px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${(loadingProgress.current / loadingProgress.total) * 100}%`,
                    height: '100%',
                    backgroundColor: '#10b981',
                    transition: 'width 0.3s ease'
                  }}></div>
                </div>
              </div>

              {/* Últimos resultados */}
              {loadingResults.length > 0 && (
                <div>
                  <h4 style={{ margin: '0 0 15px', fontSize: '14px', color: '#374151' }}>
                    Últimos registros procesados:
                  </h4>
                  <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {loadingResults.slice(-5).map((result, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 12px',
                        marginBottom: '5px',
                        backgroundColor: result.success ? '#f0fdf4' : '#fef2f2',
                        borderRadius: '6px',
                        fontSize: '13px'
                      }}>
                        <div style={{ marginRight: '8px' }}>
                          {result.success ? '✅' : '❌'}
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong>Registro {result.row}:</strong> {result.data.nombreOperador || 'Sin nombre'}
                        </div>
                        {!result.success && (
                          <div style={{ fontSize: '11px', color: '#dc2626', maxWidth: '200px' }}>
                            {result.error}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="csv-modal-footer">
              <div className="csv-modal-footer-info">
                {!isLoadingData && (
                  <span style={{ color: '#10b981', fontWeight: '500' }}>
                    ✅ Proceso completado: {loadingResults.filter(r => r.success).length} exitosos, {loadingResults.filter(r => !r.success).length} errores
                  </span>
                )}
              </div>
              <div className="csv-modal-footer-actions">
                {!isLoadingData && (
                  <button onClick={() => setShowLoadingModal(false)} className="csv-modal-footer-button">
                    Cerrar
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CSVImporter;